import { render, staticRenderFns } from "./CustomLinksEditModal.vue?vue&type=template&id=070f681c&scoped=true&"
import script from "./CustomLinksEditModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomLinksEditModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f681c",
  null
  
)

export default component.exports